import { Box, Typography } from '@mui/material';
import ListCell from 'components/list/list-cell';
import { BodyTableRow } from 'components/list/list-row';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OpenSlot } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/order-assortment.type';
import { BluBox } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/utils/styled-components';

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.cards.orderStatusInfo';

type Props = {
  openSlot: OpenSlot;
};

const OpenSlotRowBody: React.FC<Props> = ({ openSlot }) => {
  return (
    <BodyTableRow>
      <ListCell>
        <Box display={'flex'} flexDirection={'row'} gap={4}>
          <BluBox>
            <Typography variant="h5" fontWeight={'800'}>
              <FormattedMessage id={`${PAGE_NAME_ID}.open.openQuestionTitle`} />
            </Typography>

            <Typography variant="body2" fontSize={14}>
              <FormattedMessage
                id={`${PAGE_NAME_ID}.open.openAnswerContent`}
                values={{
                  br: <></>,
                }}
              />
            </Typography>
          </BluBox>

          {!openSlot.canCreateOrder && (
            <BluBox>
              <Typography variant="h5" fontWeight={'800'}>
                <FormattedMessage id={`${PAGE_NAME_ID}.open.cannotCreateOrderQuestion`} />
              </Typography>
              <Typography variant="body2" fontSize={14}>
                <FormattedMessage id={`${PAGE_NAME_ID}.open.cannotCreateOrderAnswer`} />
              </Typography>
            </BluBox>
          )}
        </Box>
      </ListCell>
    </BodyTableRow>
  );
};

export default React.memo(OpenSlotRowBody);
